import { getRoleList } from '@/api/myweb/organization/staffManagement'
export const dataMixin = {
  data() {
    return {}
  },
  methods: {
    async getRoleList() {
      let res = await getRoleList()
      console.log(res)
      if (res.status === true) {
        this.roleList = res.data
      } else {
        // this.$Message.error(res.message)
      }
    }
  }
}
